import Script from "src/component/script/Script";
import UIManifest from "src/engine/ui/UIManifest";
import { IInfo } from "src/component/props/PropsGGEditor/exec/ExecScript";
import { IPageModal } from "src/engine/pages/ui/Page";

interface IClickShowModal {
    ename: string;
    props?: string;
    clear?: boolean;
}

/**
 *
 *
 * @class ClickShowModal
 */
@UIManifest.declare("ClickShowModal", "打开页面弹框", UIManifest.Type.Script)
class ClickShowModal extends Script<IClickShowModal> {
    exec(config: IInfo, callback: (info: IInfo) => any) {
        const { pageContext } = this.context.context;
        const { ename, props = {}, clear } = this.props;

        const modal: IPageModal = { ename, modelProps: { ...config.value, ...props } };

        if (pageContext && modal.ename) {
            pageContext.showModal(modal, { clear });
        }

        return true;
    }
}

export default ClickShowModal;
